import {NgModule} from '@angular/core';
import {L10nPipe} from './l10n.pipe';

@NgModule({
    declarations: [
        L10nPipe
    ],
    exports: [
        L10nPipe
    ]
})
export class L10nModule {}
